'use client';

import { handleChunkError } from '@instamenu/react-hooks';
import NextError from 'next/error';
import { useEffect } from 'react';
import { captureClientException } from '@instamenu/posthog/client';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (handleChunkError(error)) return;

    captureClientException(error, {
      digest: error.digest,
      source: 'global-error',
    });
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
